import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { ICustomOverlayContainer } from '@siza-staff-care/shared/interfaces';
import { assertDefined } from '@siza-staff-care/shared/utils';

@Injectable({
	providedIn: 'root',
})
export class CdkOverlayContainer extends OverlayContainer implements ICustomOverlayContainer {
	private containerElements: HTMLElement[] = [];

	/**
	 * Set the container element from the outside, e.g. from the corresponding directive
	 */
	public setContainerElement(element: HTMLElement): void {
		// Get the existing container element - which lazily creates it if it doesn't already exist.
		const existing = this.getContainerElement();
		assertDefined(existing);

		// Save it on the stack so we can restore it later
		this.containerElements.push(existing);

		// Replace the existing container element with the provided one.
		this._containerElement = element;
	}

	public popContainerElement(): void {
		const popped = this.containerElements.pop();
		assertDefined(popped);
		this._containerElement = popped;
	}
}
